/**
 * tdesign v1.5.1
 * (c) 2023 tdesign
 * @license MIT
 */

import { defineComponent, toRefs, provide, reactive, createVNode, mergeProps } from 'vue';
import props from './props.mjs';
import _BreadcrumbItem from './breadcrumb-item.mjs';
import { useTNodeJSX } from '../hooks/tnode.mjs';
import { usePrefixClass } from '../hooks/useConfig.mjs';
import '../_chunks/dep-fa22eda7.mjs';
import '../_chunks/dep-8a0ff305.mjs';
import 'tdesign-icons-vue-next';
import './breadcrumb-item-props.mjs';
import '../tooltip/index.mjs';
import '../tooltip/tooltip.mjs';
import '../_chunks/dep-1ec078b3.mjs';
import '../_chunks/dep-558fadc3.mjs';
import '../_chunks/dep-1f286011.mjs';
import '../_chunks/dep-34428f12.mjs';
import '../_chunks/dep-1c40d002.mjs';
import '../_chunks/dep-3ced59c9.mjs';
import '../_chunks/dep-ad4331e8.mjs';
import '../_chunks/dep-2a69909d.mjs';
import '../_chunks/dep-e9ff4ce8.mjs';
import '../_chunks/dep-c54c9f32.mjs';
import '../_chunks/dep-c24f5c5d.mjs';
import '../_chunks/dep-61150968.mjs';
import '../_chunks/dep-31d34e52.mjs';
import '../_chunks/dep-67e8723b.mjs';
import '../_chunks/dep-0bf03d55.mjs';
import '../_chunks/dep-5b5daf08.mjs';
import '../_chunks/dep-95049222.mjs';
import '../_chunks/dep-ac19a2b6.mjs';
import '../_chunks/dep-90d97bcb.mjs';
import '../_chunks/dep-c8679a16.mjs';
import '../_chunks/dep-939a74d6.mjs';
import '../_chunks/dep-e4f65bc4.mjs';
import '../_chunks/dep-45572c49.mjs';
import '../_chunks/dep-1aa18f5f.mjs';
import '../_chunks/dep-e09a06d8.mjs';
import '../_chunks/dep-07f3660d.mjs';
import '../_chunks/dep-0d3220b0.mjs';
import '../_chunks/dep-895678a0.mjs';
import '../_chunks/dep-b2bdc7b9.mjs';
import '../_chunks/dep-0f45a6e0.mjs';
import '../_chunks/dep-16b9f817.mjs';
import '../_chunks/dep-e40749a5.mjs';
import '../_chunks/dep-8b3be089.mjs';
import '../_chunks/dep-c40264c0.mjs';
import '../_chunks/dep-437754aa.mjs';
import '../_chunks/dep-6dbd6c24.mjs';
import '../_chunks/dep-25b8bf4b.mjs';
import '../tooltip/props.mjs';
import '../popup/props.mjs';
import '../popup/index.mjs';
import '../popup/popup.mjs';
import '@popperjs/core';
import '../_chunks/dep-a861ee00.mjs';
import '../_chunks/dep-3514a375.mjs';
import '../_chunks/dep-b390ff23.mjs';
import '../hooks/index.mjs';
import '../hooks/icon.mjs';
import '../hooks/slot.mjs';
import '../hooks/useCommonClassName.mjs';
import '../config-provider/useConfig.mjs';
import '../_chunks/dep-4371fb57.mjs';
import '../_chunks/dep-35a4fd8d.mjs';
import '../_chunks/dep-54378e60.mjs';
import '../_chunks/dep-9d499243.mjs';
import '../_common/js/global-config/default-config.mjs';
import '../_common/js/global-config/locale/zh_CN.mjs';
import '../_chunks/dep-0927ceb7.mjs';
import '../_chunks/dep-f0bd05df.mjs';
import '../config-provider/type.mjs';
import '../hooks/useDefaultValue.mjs';
import '../_chunks/dep-398227bb.mjs';
import '../_chunks/dep-84053b94.mjs';
import '../hooks/useDestroyOnClose.mjs';
import '../hooks/useKeepAnimation.mjs';
import '../hooks/useRipple.mjs';
import '../utils/set-style.mjs';
import '../hooks/useVirtualScroll.mjs';
import '../hooks/useVModel.mjs';
import '../hooks/useImagePreviewUrl.mjs';
import '../_common/js/upload/utils.mjs';
import '../_common/js/log/log.mjs';
import '../utils/dom.mjs';
import '../utils/easing.mjs';
import '../_common/js/utils/set-style.mjs';
import '../popup/container.mjs';
import '../_chunks/dep-be6b014c.mjs';
import '../hooks/useResizeObserver.mjs';
import '../utils/withInstall.mjs';
import './style/css.mjs';
import '../popup/type.mjs';
import '../_chunks/dep-c25d13e7.mjs';
import '../_chunks/dep-79d42d5d.mjs';
import '../_chunks/dep-979d7716.mjs';
import '../utils/render-tnode.mjs';
import '../_chunks/dep-55311368.mjs';
import '../tooltip/util.mjs';
import '../tooltip/type.mjs';
import '../hooks/useGlobalIcon.mjs';

var _Breadcrumb = defineComponent({
  name: "TBreadcrumb",
  props: props,
  setup: function setup(props2, _ref) {
    var slots = _ref.slots;
    var _toRefs = toRefs(props2),
      separator = _toRefs.separator,
      theme = _toRefs.theme,
      maxItemWidth = _toRefs.maxItemWidth;
    var COMPONENT_NAME = usePrefixClass("breadcrumb");
    provide("tBreadcrumb", reactive({
      separator: separator,
      theme: theme,
      slots: {
        separator: slots.separator
      },
      maxItemWidth: maxItemWidth
    }));
    var renderTNodeJSX = useTNodeJSX();
    return function () {
      var content = renderTNodeJSX("default");
      if (props2.options && props2.options.length) {
        content = props2.options.map(function (option, index) {
          return createVNode(_BreadcrumbItem, mergeProps(option, {
            "key": index
          }), {
            "default": function _default() {
              return [option["default"] || option.content];
            }
          });
        });
      }
      return createVNode("div", {
        "class": COMPONENT_NAME.value
      }, [content]);
    };
  }
});

export { _Breadcrumb as default };
//# sourceMappingURL=breadcrumb.mjs.map
